/**
 * Onboarding Create Case Page
 *
 * WO-SETUP-WIZARD-001: Redirect to unified setup wizard
 *
 * This page redirects first-time users to the setup wizard that:
 * - Completes user setup (state, attorney info)
 * - Creates first case
 * - Creates first journal entry
 * - Is resumable and skippable
 */

import { Navigate, useSearchParams } from 'react-router-dom';

export default function CreateCasePage() {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo') || undefined;

  // Redirect to unified setup wizard
  const destination = returnTo
    ? `/onboarding/setup?returnTo=${encodeURIComponent(returnTo)}`
    : '/onboarding/setup';

  return <Navigate to={destination} replace />;
}
